import { RecommendationRun } from "../api/RecommendationRunApi";

export const RECOMMENDATION_RUN_CANCELLED_MESSAGE =
  "Ejecución cancelada por el usuario";

export function isRecommendationRunCancelled(
  run: Pick<RecommendationRun, "error_message">,
): boolean {
  return run.error_message === RECOMMENDATION_RUN_CANCELLED_MESSAGE;
}
